import { Icon } from "@lattice-php/ui/icons";
import { DataTableSortBar } from "@lattice-php/table/primitives/data-table";
import { IconButton } from "@lattice-php/ui/primitives/icon-button";
import { useT } from "@lattice-php/ui/i18n";
import { getSortDirectionLabel } from "@lattice-php/table/lib/query";
import type { TableColumn, TableSort, TableQuery } from "@lattice-php/table/types";

export function SortBar({
  columnsByKey,
  query,
  processing,
  onClear,
}: {
  columnsByKey: Map<string, TableColumn>;
  query: TableQuery;
  processing: boolean;
  onClear: (sort: TableSort) => void;
}) {
  const { t } = useT("lattice");

  return (
    <DataTableSortBar>
      {query.sorts.map((sort, index) => {
        const column = columnsByKey.get(sort.key);
        const label = column?.props.label ?? sort.key;
        const arrow = sort.direction === "desc" ? "arrow-down" : "arrow-up";

        return (
          <span key={sort.key} className="inline-flex items-center gap-1.5">
            <span className="font-medium">{`${index + 1}. ${label}`}</span>
            <Icon
              name={arrow}
              role="img"
              aria-hidden={false}
              aria-label={getSortDirectionLabel(sort.direction)}
              className="size-lt-icon-sm text-lt-muted-fg"
            />
            <IconButton
              size="xs"
              icon="x"
              label={t("table.sort.clear", "Clear {{label}} sort", { label })}
              data-test={`clear-${sort.key}-sort`}
              disabled={processing}
              onClick={() => onClear(sort)}
            />
          </span>
        );
      })}
    </DataTableSortBar>
  );
}
